export default __webpack_public_path__ + "static/media/olatoye.78037397.png";